import {NgModule} from '@angular/core';
import {MachineOverviewService} from '@presentation/pages/machine-overview/overview-machines-views/overview-machines-list/machine-overview.service';
import {TextileDataSharedModule} from '@presentation/pages/textile-data/textile-data-shared.module';
import {CrudOverviewDataModule, EditorHeaderModule, SplitButtonModule} from '@vdw/angular-component-library';
import {MatchingCriteriaComponent} from './matching-criteria.component';

@NgModule({
  imports: [TextileDataSharedModule, EditorHeaderModule, CrudOverviewDataModule, SplitButtonModule],
  declarations: [MatchingCriteriaComponent],
  exports: [MatchingCriteriaComponent],
  providers: [MachineOverviewService]
})
export class MatchingCriteriaModule {}
